import React from "react";
import styled from "styled-components";
import { Button, ButtonProps } from "../Button";
import { SpinnerButton, SpinnerButtonProps } from "../SpinnerButton";

import { mediaQueries, style } from "../style";

/** Wrapper for 'Continue' and 'Skip' buttons */
export const ControlsContainer = styled.div`
  margin-top: ${style.vars.whitespace.large};
  /** Bottom margin is needed because button focusOutline extends outside of the button component */
  margin-bottom: ${style.vars.whitespace.small};
`;

const StyledSkipButton = styled(Button)`
  margin-top: ${style.vars.whitespace.small};

  ${mediaQueries.xlargeMin} {
    margin-top: 0;
    margin-left: ${style.vars.whitespace.regular};
  }
`;

export const ContinueButton: React.FC<SpinnerButtonProps> = ({ children, ...props }) => {
  const isSmallerThanXLarge = mediaQueries.largeMax.useMatchesBreakpoint();

  return (
    <SpinnerButton inline fullWidth={isSmallerThanXLarge} {...props}>
      {children}
    </SpinnerButton>
  );
};

export const SkipButton: React.FC<ButtonProps> = ({ children, ...props }) => {
  const isSmallerThanXLarge = mediaQueries.largeMax.useMatchesBreakpoint();

  return (
    <StyledSkipButton variation="tertiary" fullWidth={isSmallerThanXLarge} {...props}>
      {children || "Skip"}
    </StyledSkipButton>
  );
};
